// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 35,
  position: 'relative',
  textTransform: 'capitalize',
  color: 'white',
  // color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  // backgroundColor: 'grey',
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 19,
  height: 19,
  // color: 'inherit',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
